import React, {useContext} from "react";
import {Button, Col, Row, Space} from "antd";
import cx from "classnames";
import {useRouter} from "next/router";
import styles from "@/page-components/detail/Intro/styles.module.less";
import {TExamDetailFixedInfoType, TExamKind} from "@/types";
import IntroComponent from "@/page-components/detail/Intro/intro_component";
import ExamPlan, {PayState, TExamPlanItem} from "@/page-components/detail/Intro/exam_plan";
import SignupInfo from "@/page-components/detail/Intro/signup_info";
import MobileComponentWrapper from "@/components/MobileComponentWrapper";
import SignupBtn from "@/page-components/detail/Intro/mobile_signup_btn";
import {DetailContext} from "@/context/detailContext";
import HistoryPass from "@/page-components/detail/Intro/historyPass";
import PCSignupBtn from "@/page-components/detail/Intro/pc_signup_btn";
import Footer from "@/layouts/Footer/index";
import {checkHtml} from "@/utils/index";

const IntroMobile: React.FC = () => {
  const contextProps = useContext(DetailContext);
  const {signupInfo, data, isHistoryPass,userInfo} = contextProps;
  const {type,exam_info:{signup_text,fcrpd_text}, leftNavs} = data;
  const {isOrganizationAdmin} = userInfo;
  const info = data.exam_info;
  const router  = useRouter();
  const isRenderCom = (isJudgeLeida: boolean = false) => {
    if (isJudgeLeida) {
      if (isHistoryPass) {
        return false;
      }
      // 报名信息为空或者报名信息里有未付款
      if (signupInfo && Array.isArray(signupInfo) && signupInfo.length !== 0) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < signupInfo.length; i++) {
          const signupInfoItem = signupInfo[i];
          if (signupInfoItem.payState === undefined) {
            return false
          }
          return (signupInfoItem.payState === PayState.payed);
        }
      }
      return false;
    }
    if (isHistoryPass) {
      return true;
    }
    // 报名信息为空或者报名信息里有未付款
    if (signupInfo && Array.isArray(signupInfo) && signupInfo.length !== 0) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < signupInfo.length; i++) {
        const signupInfoItem = signupInfo[i];
        if (signupInfoItem.payState === undefined) {
          return false
        }
        return (signupInfoItem.payState === PayState.payed);
      }
    }
    return false;

  }
  return (
    <div className={styles.intro_wrapper}>
      {info && (
        <div className={styles.intro}>
          <div className={styles.intro_mobile_inner}>
            <div className={styles.item}>
              <>
                {isRenderCom() ? (
                  <>
                    {isHistoryPass ? (
                      <HistoryPass
                        isOrganizationAdmin={isOrganizationAdmin}
                        type={type}
                        pass_tips={info.pass_tips}
                        pass_link={info.pass_link}
                      />) : (
                      <SignupInfo
                        type={type}
                        allData={signupInfo}
                        data={signupInfo[0]}
                      />
                    )}
                  </>
                ) : (
                  <>
                    <div style={{flex: 1}}>
                      <div className={styles.title}>报考说明</div>
                      <div className={styles.row}>
                        <Space size={4}>
                          <p className={styles.subtitle}>报考要求:</p>
                          {checkHtml(info?.require) ? <div className={styles.subtitle_text} dangerouslySetInnerHTML={{__html:info?.require}}/> : <p className={styles.subtitle_text}>{info?.require}</p>}
                        </Space>
                      </div>
                      <div className={styles.row}>
                        <Space size={4}>
                          <p className={styles.subtitle}>考试时长:</p>
                          <p className={styles.subtitle_text}>{info?.duration}</p>
                        </Space>
                      </div>
                      <div className={styles.row}>
                        <Space size={4}>
                          <p className={styles.subtitle}>报考费用:</p>
                          <p className={styles.subtitle_text}>{info?.exam_money === 0 ? '免费' : `${info?.exam_money}元`}</p>
                        </Space>
                      </div>
                      {info?.subjects && (
                        <div className={styles.row}>
                          <Space align="start" size={4}>
                            <p className={styles.subtitle}>考试科目：</p>
                            <div>
                              {info?.subjects.map((item, index) => {
                                return (
                                  <div key={item.label}>
                                    <Space size={4}>
                                      <p className={styles.subtitle_text}>{item.label}</p>
                                      <p className={styles.subtitle_text_score_text}>{item.price}元</p>
                                    </Space>
                                  </div>
                                )
                              })}
                            </div>
                          </Space>
                        </div>
                      )}
                      <div className={styles.row}>
                        <Space size={4} align="start">
                          <p className={styles.subtitle}>通过条件:</p>
                          <p className={styles.subtitle_text}>{info?.pass_condition}</p>
                        </Space>
                      </div>
                    </div>
                    {/*<Row gutter={16} className={styles.btn_row}>*/}
                    {/*  <Col span={12}>*/}
                    {/*    <PCSignupBtn*/}
                    {/*      payState={signupInfo.length > 0 ? signupInfo[0].payState : undefined}*/}
                    {/*    />*/}
                    {/*  </Col>*/}
                    {/*  <Col span={12}>*/}
                    {/*    <Button className={styles.simple_btn} onClick={() => {*/}
                    {/*      router.push('/verify')*/}
                    {/*    }}>证书&成绩查询</Button>*/}
                    {/*  </Col>*/}
                    {/*</Row>*/}
                  </>
                )}
              </>
            </div>
            <div className={styles.item}>
              {isRenderCom(true)? (
                <ExamPlan type={type} data={signupInfo}/>
              ) : (
                <>
                  <p className={styles.title}>能力雷达</p>
                  <div className={styles.leida_img_wrapper}>
                    <img alt="" src={info.leida_url} className={styles.leida_img}/>
                  </div>
                </>
              )}
            </div>
          </div>
          <Row className={styles.item}>
            {leftNavs.map((item,index) => {
              return (
                <Col
                  key={String(Math.random())}
                  span={8}
                  className={styles.small_item}
                >
                  <IntroComponent
                    href={item.href}
                    icon={`/img/detail/nav_icon${index+1}.png`}
                    title={item.label}
                    english_title={item.english_label}
                  />
                </Col>
              )
            })}
          </Row>
        </div>
      )}
      <MobileComponentWrapper>
        {!isRenderCom() && (
          <>
            <Footer className={styles.intro_footer}/>
            <Row className={styles.detail_footer}>
              <Col span={12}>
                <SignupBtn
                  payState={signupInfo.length >0?signupInfo[0].payState : undefined}
                  fcrpd_text={fcrpd_text}
                  signupText={signup_text}
                  isInMobile
                  className={styles.btn}
                  type={type}
                />
              </Col>
              <Col span={12}>
                <Button className={cx(styles.btn,styles.cancel_btn)} onClick={() => {
                  router.push('/verify')
                }}>证书&成绩查询</Button>
              </Col>
            </Row>
          </>
        )}
      </MobileComponentWrapper>
    </div>
  )
}
export default IntroMobile;
